import {
  getBackApplicazioniAnagraficaFasi,
  getGetBackApplicazioniAnagraficaFasiQueryOptions,
} from '@framework/api-client/api/backoffice/applicazioni/applicazioni.ts';
import { type AnagraficaFasiDTO } from '@framework/api-client/api/inquiries-compile/schemas/anagraficaFasiDTO.ts';
import { AsyncSelectInput } from '@framework/form/inputs/AsyncSelectInput.tsx';

export interface IPhaseAsyncSelectInputProps {
  name: string;
}

/**
 * Input per la selezione dello fase di una procedura o pratica da ricercare.
 */
export function PhaseAsyncSelectInput(props: IPhaseAsyncSelectInputProps) {
  const { name } = props;

  return (
    <AsyncSelectInput
      name={name}
      // Apre verso l'alto: nel popover FilterBar non deve coprire "Applica".
      placement="topLeft"
      size="middle"
      placeholder="Fase..."
      queryFn={getBackApplicazioniAnagraficaFasi}
      queryOptions={() => getGetBackApplicazioniAnagraficaFasiQueryOptions()}
      asOption={(phase: AnagraficaFasiDTO) => ({
        value: phase.denominazione!,
        label: phase.denominazione!,
      })}
    />
  );
}
